import React from 'react';
import { Spin } from 'antd';

const LoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 240 }}>
    <Spin size="large" />
  </div>
);

export default LoadingFallback;
